import type { SxProps, Theme } from "@mui/material";
import type { PropsWithChildren } from "react";
import FieldPopover from "../../../../viewer/common/fields/FieldPopover.tsx";

interface Props {
  anchorEl: HTMLElement | null;
  cancel: (event: React.MouseEvent<HTMLElement>) => void;
  sx?: SxProps<Theme>;
}

const FieldOptionPopupContainer = ({ anchorEl, children, cancel, sx }: PropsWithChildren<Props>) => {
  if (anchorEl === null) return null;
  return (
    <FieldPopover open={true} anchorEl={anchorEl} onClose={cancel} sx={{ width: 400, p: 0, ...sx }}>
      {children}
    </FieldPopover>
  );
};
export default FieldOptionPopupContainer;
